import { Presentation, IPresentationConfig, PresentationState } from "@nolimitcity/slot-game/bin/core/gamecontroller/presentations/Presentation";

export class IntroPresentation extends Presentation {

    constructor(config?:IPresentationConfig) {
        super(config);
        this.PresentationState.set(PresentationState.ACTIVATED);
    }

    public getPresentation(){
        this.Intro();
    }

    public initialization():void{
    }

    public stopPresentation():void{
    }

    private Intro():void{
        this.PresentationState.set(PresentationState.INACTIVE);
    }

    public skipPresentation():void{
        this.pTimeline.totalProgress(1);
    }
}